import type { Epic } from '../../index.js'
import { filter, map, mergeMap, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../Framework/Epic/AuthenticationExpired.js'
import { handleBatchUpdateSamples } from '../Common/handleBatchUpdateSamples.js'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

export const ProjectBatchUpdateSamplesEpic: Epic = (action$, state$, { OrderRepository }) =>
  action$.pipe(
    filter(projectSlice.actions.batchUpdateSamples.match),
    mergeMap((action) =>
      handleBatchUpdateSamples(action.payload, OrderRepository).pipe(
        map(({ newMetadata, updatedMetadata, samples, batch }) =>
          projectSlice.actions.batchUpdateSamplesSuccess({
            batch,
            result: { newMetadata, updatedMetadata, samples },
          })
        ),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(projectSlice.actions.batchUpdateSampleFailure(error))
          })
        )
      )
    )
  )
